import _ from 'lodash'
import Parser from './parser.js'
import { isLogop } from './operators.js'

export default class Formatter {
  constructor (enableCache = false) {
    this.parser = new Parser(enableCache)
  }

  indent (s, depth) {
    return `${_.repeat(' ', depth)}${_.trim(s)}`
  }

  format (formula) {
    return this.render(this.parser.parse(formula))
  }

  render (node, depth = 0) {
    if (isLogop(node?.operator)) {
      node.type = 'LogicalExpression'
    }

    switch (node?.type) {
      case 'Literal':
        return this.indent(_.isString(node.value) ? `'${node.value}'` : node.value, depth)
      case 'Identifier':
        return this.indent(node.name, depth)
      case 'Task':
        return this.indent(_.chain([node.task, node.name]).compact().join('::').castArray().concat(_.trim(this.render(node.taskArg, depth))).compact().join('(').castArray().concat(node.taskArg && ')').compact().join('').value(), depth)
      case 'Vrn':
        return this.indent(node.vrn, depth)
      case 'Annotation':
        return this.indent(`#${node.annotation}:${_.trim(this.render(node.expression, depth))}`, depth)
      case 'Property':
        return this.indent(`${this.render(node.key, depth)}: ${_.trim(this.render(node.value, depth))}`, depth)
      case 'Compound':
        return this.indent(_.chain(node.body).map(n => _.trim(this.render(n, depth))).join(' ').value(), depth)
      case 'SequenceExpression':
        return this.indent(_.chain(node.expressions).map(n => _.trim(this.render(n, depth))).join(' ').value(), depth)
      case 'MemberExpression':
        return this.indent(node.computed ? `${this.render(node.object, depth)}[${_.trim(this.render(node.property, depth))}]` : `${this.render(node.object, depth)}.${_.trim(this.render(node.property, depth))}`, depth)
      case 'UnaryExpression':
        return this.indent(`${node.operator}${_.trim(this.render(node.argument, depth))}`, depth)
      case 'LogicalExpression':
        return this.indent(`(\n${this.render(node.left, depth + 1)}\n${this.indent(node.operator, depth + 1)}\n${this.render(node.right, depth + 1)}\n${this.indent(')', depth)}`, depth)
      case 'BinaryExpression':
        return this.indent(`(${_.trim(this.render(node.left, depth))} ${node.operator} ${_.trim(this.render(node.right, depth))})`, depth)
      case 'ConditionalExpression':
        return this.indent(`(${_.trim(this.render(node.test, depth))} ? ${_.trim(this.render(node.consequent, depth))} : ${_.trim(this.render(node.alternate, depth))})`, depth)
      case 'CallExpression':
        return _.size(node.arguments) > 1 ? this.indent(`${this.render(node.callee, depth)}(\n${_.chain(node.arguments).map(n => this.render(n, depth + 1)).join(',\n').value()}\n${this.indent(')', depth)}`, depth) : this.indent(`${this.render(node.callee, depth)}(${_.chain(node.arguments).map(n => _.trim(this.render(n, depth))).join(',').value()})`, depth)
      case 'ArrayExpression':
        return _.size(node.elements) > 1 ? this.indent(`[\n${_.chain(node.elements).map(n => this.render(n, depth + 1)).join(',\n').value()}\n${this.indent(']', depth)}`, depth) : this.indent(`[${_.chain(node.elements).map(n => _.trim(this.render(n, depth))).join(',').value()}]`, depth)
      case 'ObjectExpression':
        return _.size(node.properties) > 1 ? this.indent(`{\n${_.chain(node.properties).map(n => this.render(n, depth + 1)).join(',\n').value()}\n${this.indent('}', depth)}`, depth) : this.indent(`{${_.chain(node.properties).map(n => _.trim(this.render(n, depth))).join(',').value()}}`, depth)
      case 'TemplateLiteral':
        return this.indent(`\`${_.chain(node.quasis).map((n, i) => n?.tail ? this.render(n) : `${this.render(n, depth)}\${${this.render(node?.expressions[i])}}`).join('').value()}\``, depth)
      case 'TemplateElement':
        return node.value.cooked || node.value.raw
    }
  }
}
